var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"responsive":"sm","hover":true,"striped":""},scopedSlots:_vm._u([{key:"cell(x)",fn:function({ item }){return [_vm._v("\n    "+_vm._s(_vm.formatDatetime(item.x))+"\n  ")]}},{key:"cell(y)",fn:function({ item }){return [_vm._v("\n    "+_vm._s(item.y)+_vm._s(_vm.dataset.unit)+"\n  ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }